import VIcon from './VIcon.vue';

export { VIcon };
export default VIcon;
